import { memo } from 'react';

import { ChevronLeftIcon, ChevronRightIcon, TrendingUpIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { cn } from '@air/utils-tailwind';

export type WorkspaceAgentPromptCardCarouselControlsProps = {
  labelId: string;
  listId: string;
  onScrollNext: (() => void) | undefined;
  onScrollPrev: (() => void) | undefined;
};

export const WorkspaceAgentPromptCardCarouselControls = memo(
  ({ labelId, listId, onScrollNext, onScrollPrev }: WorkspaceAgentPromptCardCarouselControlsProps) => (
    <div className="flex items-center justify-between gap-2">
      <p
        className="flex items-center gap-1 py-1 font-medium ads:text-secondary text-12 text-gray-11 leading-4"
        id={labelId}
      >
        <TrendingUpIcon aria-hidden className="shrink-0 ads:text-icon-subtle text-gray-9" size="xs" />
        Prompts to try
      </p>
      <div className="flex shrink-0 items-center gap-0.5">
        <IconButton
          appearance="ghost"
          aria-controls={listId}
          aria-disabled={!onScrollPrev}
          className={cn(!onScrollPrev && 'pointer-events-none opacity-40')}
          color="gray"
          data-testid="WORKSPACE_AGENT_PROMPT_CARD_CAROUSEL_PREVIOUS"
          label="Previous"
          onClick={onScrollPrev}
          size="small"
        >
          <ChevronLeftIcon aria-hidden size="sm" />
        </IconButton>
        <IconButton
          appearance="ghost"
          aria-controls={listId}
          aria-disabled={!onScrollNext}
          className={cn(!onScrollNext && 'pointer-events-none opacity-40')}
          color="gray"
          data-testid="WORKSPACE_AGENT_PROMPT_CARD_CAROUSEL_NEXT"
          label="Next"
          onClick={onScrollNext}
          size="small"
        >
          <ChevronRightIcon aria-hidden size="sm" />
        </IconButton>
      </div>
    </div>
  ),
);

WorkspaceAgentPromptCardCarouselControls.displayName = 'WorkspaceAgentPromptCardCarouselControls';
